import { render, staticRenderFns } from "./shedi.vue?vue&type=template&id=bd54f71c&scoped=true"
import script from "./shedi.vue?vue&type=script&lang=ts"
export * from "./shedi.vue?vue&type=script&lang=ts"
import style0 from "./shedi.vue?vue&type=style&index=0&id=bd54f71c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd54f71c",
  null
  
)

export default component.exports